module.exports = __webpack_public_path__ + "img/twoPic.40bfa3b9.png";